// Accessibility skip link per FR-9 and accessibility.md. Hidden until
// focused; jumps the keyboard user past the sticky nav to the first
// in-page heading. The target `<main id="main-content">` lives in
// CustomerApp.tsx so every route benefits without per-page wiring.
export function SkipLink(): JSX.Element {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded focus:bg-brand-black focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-brand-white"
    >
      Skip to main content
    </a>
  );
}
